import * as confirmAction from "../../../store/confirm/action";
import * as loadingAction from "../../../store/loading/action";
import * as messageAction from "../../../store/message/action";
import * as tpaDailyReportAction from "../../../store/tpadaily-report/action";
import { post, postUpload } from "../../../helpers/api_helper";
import "flatpickr/dist/themes/material_blue.css";
import React, { useState, useEffect, useMemo } from "react";

import {
    SAVE_EVENT_RP_TPA_DAILY_REPORT,
    SAVE_LIST_EVENT_RP_TPA_DAILY_REPORT,
    DELETE_EVENT_RP_TPA_DAILY_REPORT,
    GET_EVENT_RP_TPA_DAILY_REPORT
} from "../../../helpers/url_api_constant";

import {
    Col,
    Input,
    Row,
    InputGroup,
} from "reactstrap";

import PropTypes from "prop-types";
import BootstrapTable from "react-bootstrap-table-next";
import "../../../assets/scss/datatables.scss";
import OverButton from "../../../components/Custom/Overbutton";
import { Link, useHistory, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import moment from "moment";
import { getPermission, getUserToken } from "../../../helpers/auth_helper";;
import Flatpickr from "react-flatpickr";
import debounce from "lodash.debounce";

function TableOne(props) {
    // console.log(props);
    let history = useHistory();
    let { pid } = useParams();

    const permission = getPermission();
    const searchObj = { TPADAILY_PID: pid, };
    // const createObj = {};
    const dispatch = useDispatch();
    const [modelDeviceList, setModelDeviceList] = useState([]);
    // const [createModel, setCreateModel] = useState(createObj);
    const [searchModel, setSearchModel] = useState(searchObj);


    // Action Button//
    const ButtonAction = (cellContent, row, index) => {
        return (
            <div>
                {permission.eTPA && (
                    <OverButton
                        onClick={() => {
                            handleTable1DeleteRow(row, index);
                        }}
                        color="danger"
                        icon="fas fa-trash-alt"
                        label="Delete"
                    />
                )}
            </div>
        );
    };
    // Action Button//

    //render Index//
    const CountIndexRow = (cell, row, rowIndex) => rowIndex + 1;
    //render Index//

    const rowStyleFontWhite = (row, rowIndex) => {
        const style = {};
        // style.fontWeight = 'bold';
        style.color = 'white';

        return style;
    };

    const InputTimeInTable = (cellContent, row) => {
        return (
            <div className="d-flex align-items-center justify-content-center">
                <Col sm={12}>
                    <InputGroup>
                        <Flatpickr
                            className="form-control d-block"
                            placeholder="Select time"
                            disabled={props.readOnly}
                            options={{
                                enableTime: true,
                                noCalendar: true,
                                dateFormat: "H:i",
                                time_24hr: true,
                                defaultDate: new Date()
                            }}
                            onChange={(value) => {
                                setModelDeviceList(prevData => {
                                    return prevData.map(item => {
                                        if (item.ROW === row.ROW) {
                                            return { ...item, TPAEVENT_TIME: value[0] };
                                        }
                                        return { ...item };
                                    });
                                })
                            }
                            }
                            value={row.TPAEVENT_TIME}
                        />
                        <div className="input-group-append">
                            <span className="input-group-text">
                                <i className="mdi mdi-clock-outline" />
                            </span>
                        </div>
                    </InputGroup>
                </Col>
            </div>
        );
    };

    const InputRemark = (cellContent, row) => {
        return (
            <div className="d-flex align-items-center justify-content-center">
                <Col sm={12}>
                    <Input
                        type="text"
                        className="form-control basicborder"
                        // disabled={permission.eAPI != true}
                        maxLength="230"
                        readOnly={props.readOnly}
                        onChange={e => {
                            // console.log(e.target.value);
                            setModelDeviceList(prevData => {
                                return prevData.map(item => {
                                    // console.log(item);
                                    if (item.ROW === row.ROW) {
                                        return { ...item, TPAEVENT_DETAIL: e.target.value };
                                    }
                                    return { ...item };
                                });
                            })
                        }
                        }
                        value={row.TPAEVENT_DETAIL}
                    />
                </Col>
            </div>
        );
    };

    //headerColumn
    const columns = [
        {
            dataField: "Dummy",
            text: "ที่",
            headerAlign: "center",
            align: "center",
            headerStyle: {
                width: "5%",
                fontSize: "14px",
            },
            style: {
                width: "5%",
            },
            formatter: CountIndexRow,
        },
        {
            dataField: "TIME",
            text: "เวลา",
            headerAlign: "center",
            align: "center",
            headerStyle: {
                width: "15%",
                fontSize: "14px",
            },
            style: {
                width: "15%",
            },
            sort: false,
            // isDummyField: true,
            formatter: InputTimeInTable,
        },
        {
            dataField: "REMARK",
            text: "รายละเอียดเหตุการณ์",
            headerAlign: "center",
            align: "center",
            headerStyle: {
                width: "80%",
                fontSize: "14px",
            },
            style: {
                width: "80%",
            },
            sort: false,
            // isDummyField: true,
            formatter: InputRemark,
        },

        {
            dataField: "df1",
            text: "",
            isDummyField: true,
            hidden: props.readOnly,
            formatter: ButtonAction,
            headerAlign: "center",
            align: "left",
            headerStyle: {
                width: "1%",
                fontSize: "14px",
            },
            style: {
                width: "1%",
            },
        },
    ];
    //headerColumn

    const setDispatchAction = useMemo(
        () =>
            debounce((value) => {
                dispatch(
                    tpaDailyReportAction.setTableOneEventTPAToState(value)
                );
            }, 300),
        []
    );
    useEffect(() => {
        setDispatchAction([...modelDeviceList.map(item => {
            return {
                ...item, TPAEVENT_TIME: moment(item.TPAEVENT_TIME).format("H:mm"),
            }
        })]);
    }, [modelDeviceList]);

    const handleTable1AddRow = () => {
        setModelDeviceList(prevent => [
            ...prevent,
            {
                ROW: modelDeviceList.length + 1,
                PID: "",
                TPADAILY_PID: props.tpaDailyReportPid,
                TPAEVENT_TIME: new Date(),
                TPAEVENT_DETAIL: "",
            },
        ]);
    };

    const handleTable1DeleteRow = (row, index) => {
        setModelDeviceList(prevent => {
            let data = prevent.splice(index, 1);
            // console.log(prevent, data);
            return prevent.map((obj, i) => {
                // if (index != i) {
                return { ...obj, ROW: i + 1 }
                // }
            })
        });
    };

    const compare = (a, b) => {
        // console.log(a, b);
        if (a.CREATE_DATE < b.CREATE_DATE) {
            return -1;
        }
        if (a.CREATE_DATE > b.CREATE_DATE) {
            return 1;
        }
        return 0;
    }

    //onInit//
    useEffect(function () {
        fetchData();
        // resetSearch();
        // resetModel();
        // setModelDeviceList(listData);
    }, [props.tpaDailyReportPid]);
    //onInit//

    const fetchData = async () => {
        // dispatch(loadingAction.showLoading());
        try {
            let res = await post(GET_EVENT_RP_TPA_DAILY_REPORT, { TPADAILY_PID: props.tpaDailyReportPid });
            // console.log(res);
            setModelDeviceList(res.data.rpTPAEventList.sort(compare).map((obj, index) => ({
                ...obj,
                ROW: index + 1,
                TPAEVENT_TIME: moment(obj.TPAEVENT_TIME).toDate(),
            }))
            );
        } catch (error) {
            dispatch(messageAction.showMessage(error.message));
        }
        // dispatch(loadingAction.hideLoading());
    };
    return (
        // <div>
        <Row>
            <Col sm="1"></Col>
            <Col sm="10">
                <div>
                    <BootstrapTable
                        id="table1"
                        keyField="ROW"
                        data={modelDeviceList}
                        columns={columns}
                        headerClasses="header-style"
                        rowStyle={rowStyleFontWhite}
                    // defaultSorted={defaultSorted}
                    // pagination={paginationFactory(options)}
                    // hover
                    />
                </div>

                <div className="d-sm-flex align-items-center justify-content-end mt-2">
                    {permission.eTPA && props.readOnly == false && (
                        <button
                            type="submit"
                            className="btn btn-primary me-2"
                            onClick={() => handleTable1AddRow()}
                        >
                            <i className="bx bx-plus"></i> Add
                        </button>
                    )}
                </div>
            </Col>
            <Col sm="1"></Col>
        </Row>
        // </div>
    );
}


TableOne.propTypes = {
    t: PropTypes.any,
    tpaDailyReportPid: PropTypes.any,
    readOnly: PropTypes.any,
};

export default TableOne;


